import React from "react";
import {
  Datagrid,
  DateField,
  List,
  NumberInput,

  SelectInput,
  SimpleShowLayout,
  TextField,
  ReferenceInput,
  TextInput, required,
  BooleanInput,
  FormDataConsumer,
} from "react-admin";

import EditView from "../../../../components/EditView";
import CreateView from "../../../../components/CreateView";
import ShowView from "../../../../components/ShowView";
// import { makeStyles } from "@material-ui/core/styles";


// const useStyles = (width) => makeStyles({ image: { width } })();

export const BaseUnitList = (props) => {


  return (
    <List  {...props} perPage={100} sort={{ field: 'order', order: 'ASC' }} >
      <Datagrid rowClick="edit">
        <TextField source="order" />
        <TextField source="title" />
        <TextField source="symbol" />
      </Datagrid>
    </List>
  )
};

export const BaseUnitEdit = (props) => (
  <EditView {...props} perPage={10}>
    <TextInput source="title" validate={required()} />
    <NumberInput source="order" validate={required()} />
    <TextInput source="symbol" validate={required()} />
    <BooleanInput source="isBasic" />
    <FormDataConsumer >
      {({ formData, ...rest }) => !formData.isBasic && <div>
        <NumberInput variant="outlined" source="relatedUnit.ratio" style={{ marginLeft: '10px' }} />

        <ReferenceInput variant="outlined" filter={{ isBasic: true }} source="relatedUnit.unit" reference="baseUnit" >
          <SelectInput optionText="title" />
        </ReferenceInput>
      </div>
      }
    </FormDataConsumer>

  </EditView>
);

export const BaseUnitShow = (props) => (
  <ShowView {...props}>
    <SimpleShowLayout>
      <TextField source="order" />
      <TextField source="title" />
      <TextField source="symbol" />
      <DateField locales={"fa-IR"} source="createdAt" />
      <DateField locales={"fa-IR"} source="updatedAt" />
      <TextField source="objectId" />
    </SimpleShowLayout>
  </ShowView>
);

export const BaseUnitCreate = (props) => (
  <CreateView {...props}>
    <TextInput source="title" validate={required()} />
    <NumberInput source="order" validate={required()} />
    <TextInput source="symbol" validate={required()} />
    <BooleanInput source="isBasic" />
    <FormDataConsumer>
      {({ formData, ...rest }) => !formData.isBasic && <div>
        <NumberInput variant="outlined" source="relatedUnit.ratio" style={{ marginLeft: '10px' }} />

        <ReferenceInput variant="outlined" filter={{ isBasic: true }} source="relatedUnit.unit" reference="baseUnit" >
          <SelectInput optionText="title" />
        </ReferenceInput>
      </div>
      }
    </FormDataConsumer>

  </CreateView>
);
